export namespace SparkConstants {
    /**
     * Generated from com.dataiku.dip.analysis.ml.SparkConstants$Checkpoint
     */
    export enum Checkpoint {
        NONE = 'NONE',
        RESILIENT = 'RESILIENT',
        LOCAL = 'LOCAL'
    }
}